import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCelebrateIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "b",
		children: /* @__PURE__ */ _jsx("g", {
			id: "b_2",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "c",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Vector",
						d: "M24 48C37.2546 48 48 37.2546 48 24C48 10.7454 37.2546 0 24 0C10.7454 0 0 10.7454 0 24C0 37.2546 10.7454 48 24 48Z",
						fill: "#FFD525"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_2",
						d: "M14.2697 18.3895C14.2697 21.0275 12.1286 23.1686 9.49057 23.1686C6.85253 23.1686 4.71143 21.0275 4.71143 18.3895C4.71143 15.7515 6.85253 13.6104 9.49057 13.6104C12.1286 13.6104 14.2697 15.7484 14.2697 18.3895Z",
						fill: "#1C1C1C"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_3",
						d: "M9.34985 16.5399C9.34985 17.316 8.72102 17.9448 7.94495 17.9448C7.16887 17.9448 6.54004 17.316 6.54004 16.5399C6.54004 15.7638 7.16887 15.135 7.94495 15.135C8.72102 15.135 9.34985 15.7638 9.34985 16.5399Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_4",
						d: "M10.8897 18.7546C10.8897 19.2025 10.5277 19.5645 10.0798 19.5645C9.63198 19.5645 9.27002 19.2025 9.27002 18.7546C9.27002 18.3068 9.63198 17.9448 10.0798 17.9448C10.5277 17.9448 10.8897 18.3068 10.8897 18.7546Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_5",
						d: "M43.2883 18.3895C43.2883 21.0275 41.1502 23.1686 38.5091 23.1686C35.868 23.1686 33.73 21.0275 33.73 18.3895C33.73 15.7515 35.868 13.6104 38.5091 13.6104C41.1502 13.6104 43.2883 15.7484 43.2883 18.3895Z",
						fill: "#1C1C1C"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_6",
						d: "M38.3679 16.5399C38.3679 17.316 37.7391 17.9448 36.963 17.9448C36.1869 17.9448 35.5581 17.316 35.5581 16.5399C35.5581 15.7638 36.1869 15.135 36.963 15.135C37.7391 15.135 38.3679 15.7638 38.3679 16.5399Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_7",
						d: "M39.9082 18.7546C39.9082 19.2025 39.5462 19.5645 39.0984 19.5645C38.6505 19.5645 38.2886 19.2025 38.2886 18.7546C38.2886 18.3068 38.6505 17.9448 39.0984 17.9448C39.5462 17.9448 39.9082 18.3068 39.9082 18.7546Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_8",
						d: "M12.9204 27.2423C12.9204 28.5859 11.4572 29.6748 9.64738 29.6748C7.83756 29.6748 6.37744 28.5859 6.37744 27.2423C6.37744 25.8988 7.84063 24.8098 9.64738 24.8098C11.4541 24.8098 12.9204 25.8988 12.9204 27.2423Z",
						fill: "#1DBADF"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_9",
						d: "M41.6196 27.2423C41.6196 28.5859 40.1533 29.6748 38.3497 29.6748C36.546 29.6748 35.0767 28.5859 35.0767 27.2423C35.0767 25.8988 36.5429 24.8098 38.3497 24.8098C40.1564 24.8098 41.6196 25.8988 41.6196 27.2423Z",
						fill: "#1DBADF"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_10",
						d: "M23.9999 28.8068C26.5613 28.8068 28.8557 29.8099 30.4079 31.3988C31.2238 30.4694 31.8741 29.3651 32.3067 28.1381C32.8496 26.5982 31.9079 24.8958 30.503 24.8958H17.4938C16.0919 24.8958 15.1471 26.5982 15.6932 28.1381C16.1257 29.362 16.776 30.4694 17.5919 31.3988C19.1441 29.8129 21.4386 28.8068 23.9999 28.8068Z",
						fill: "#1C1C1C"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_11",
						d: "M23.9998 34.3866C26.5151 34.3866 28.7881 33.2394 30.4077 31.3958C28.8556 29.81 26.5611 28.8069 23.9998 28.8069C21.4384 28.8069 19.1439 29.81 17.5918 31.3958C19.2114 33.2394 21.4814 34.3866 23.9998 34.3866Z",
						fill: "#FF2180"
					})
				]
			})
		})
	})
});
export default SvgCelebrateIcon;
